module.exports = __webpack_public_path__ + "img/9.8f2e54c3.png";